module.exports = __webpack_public_path__ + "img/sample_img_01.26fcda2c.png";